import { type JSX, type ReactNode,useEffect } from 'react';

import { useAppSelector } from '@/app/store/hooks';
import { selectTheme } from '@/features/ui';

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * Aplica el tema seleccionado al elemento <html> añadiendo/quitando la clase `.dark`.
 * Tres modos: light, dark y system (sigue prefers-color-scheme del SO).
 */
export function ThemeProvider({ children }: ThemeProviderProps): JSX.Element {
  const theme = useAppSelector(selectTheme);

  useEffect(() => {
    const root = document.documentElement;
    const apply = (isDark: boolean): void => {
      root.classList.toggle('dark', isDark);
    };

    if (theme === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      apply(mq.matches);
      const listener = (e: MediaQueryListEvent): void => {
        apply(e.matches);
      };
      mq.addEventListener('change', listener);
      return () => {
        mq.removeEventListener('change', listener);
      };
    }

    apply(theme === 'dark');
    return undefined;
  }, [theme]);

  return <>{children}</>;
}
